import {
  IDepartmentInfoV2,
  IDiseaseDepartment,
  IDiseaseInfo
} from '@/schemas/med-dictionary';

type IDiseaseItemInfo = IDiseaseInfo & { videoCount: number };

interface IState {
  departments: IDiseaseDepartment[];
  departmentInfos: Record<number | string, IDepartmentInfoV2>;
  diseaseInfos: Record<string, IDiseaseItemInfo>;
}

const medDictionary = {
  state: { departments: [], departmentInfos: {}, diseaseInfos: {} } as IState,

  reducers: {
    updateDepartments: (state: IState, payload: IDiseaseDepartment[]) => ({
      ...state,
      ...payload
    }),

    updateDepartmentInfos: (
      state: IState,
      payload: {
        departmentId: number | string;
        departmentInfo: IDepartmentInfoV2;
      }
    ) => {
      const { departmentId, departmentInfo } = payload;
      const departmentInfos = {
        ...state.departmentInfos,
        [departmentId]: departmentInfo
      };
      return {
        ...state,
        departmentInfos
      };
    },

    updateDiseaseInfos: (
      state: IState,
      payload: {
        diseaseItemId: string;
        diseaseInfo: IDiseaseItemInfo;
      }
    ) => {
      const { diseaseItemId, diseaseInfo } = payload;
      const diseaseInfos = {
        ...state.diseaseInfos,
        [diseaseItemId]: diseaseInfo
      };
      return {
        ...state,
        diseaseInfos
      };
    }
  }
};

export default medDictionary;
